import type { AppLocaleConfig, EnabledAppLocale } from "./localeRegistry";

export type Catalog = Record<string, unknown>;
export type LocaleResources = Record<string, Catalog>;

export interface LocaleBundle {
    config: AppLocaleConfig;
    resources: LocaleResources;
}

const catalogPathPattern = /\/locales\/([^/]+)\/([^/]+)\.json$/;

export const buildLocaleResources = (catalogModules: Record<string, Catalog>, locale: EnabledAppLocale): LocaleResources => {
    const resources: LocaleResources = {};

    for (const [catalogPath, catalog] of Object.entries(catalogModules)) {
        const match = catalogPath.match(catalogPathPattern);
        if (match?.[1] === locale && match[2]) {
            resources[match[2]] = catalog;
        }
    }

    return resources;
};

const englishCatalogModules = import.meta.glob("../../../locales/en/*.json", {
    eager: true,
    import: "default",
}) as Record<string, Catalog>;

export const englishResources = buildLocaleResources(englishCatalogModules, "en");
export const defaultNamespace = "common";
export const appNamespaces = Object.keys(englishResources).sort();

const localeBundleLoaders: Record<Exclude<EnabledAppLocale, "en">, () => Promise<{ default: LocaleBundle }>> = {
    es: () => import("./catalogBundles/es"),
    fr: () => import("./catalogBundles/fr"),
    "zh-CN": () => import("./catalogBundles/zh-CN"),
    "zh-TW": () => import("./catalogBundles/zh-TW"),
    ko: () => import("./catalogBundles/ko"),
    ja: () => import("./catalogBundles/ja"),
};

export const loadLocaleBundle = async (locale: Exclude<EnabledAppLocale, "en">): Promise<LocaleBundle> => {
    return (await localeBundleLoaders[locale]()).default;
};
